<template>
  <div>
    <ValidationObserver ref="observer">
      <div>
        <v-container class="pt-5 px-5 pb-8">
          <ValidationProvider
            :name="'ภูมิลำเนา'"
            :rules="'required'"
            key="ภูมิลำเนา"
            v-slot="{ errors }"
          >
            <div class="steplabel">
              <span style="color: red">*</span>
              ภูมิลำเนา / Place of Birth
            </div>
            <div>
              <v-autocomplete
                placeholder="จังหวัด"
                :error-messages="errors"
                v-model="input.place_of_birth"
                :items="provinceOptions"
                item-text="province_name"
                return-object
                outlined
                rounded
                no-data-text="ไม่พบข้อมูลจังหวัด"
              >
              </v-autocomplete>
            </div>
          </ValidationProvider>
          <ValidationProvider
            :name="'ที่อยู่ปัจจุบัน'"
            :rules="'required'"
            key="ที่อยู่ปัจจุบัน"
            v-slot="{ errors }"
          >
            <div class="steplabel">
              <span style="color: red">*</span>
              ที่อยู่ปัจจุบัน / Current Address
            </div>
            <div>
              <v-autocomplete
                placeholder="จังหวัด"
                :error-messages="errors"
                v-model="input.current_address"
                :items="provinceOptions"
                item-text="province_name"
                return-object
                outlined
                rounded
                no-data-text="ไม่พบข้อมูลจังหวัด"
              >
              </v-autocomplete>
            </div>
          </ValidationProvider>

          <!-- <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              พื้นที่ที่สะดวกทำงาน / Location Interests
            </div>
            <div class="text-center mt-3">
              <v-btn
                @click="input.location_interest = 'กรุงเทพ'"
                rounded
                class="mr-1"
                style="letter-spacing: 0px !important"
                :style="
                  input.location_interest === 'กรุงเทพ'
                    ? 'font-weight: 600'
                    : ''
                "
                outlined
                :color="
                  input.location_interest === 'กรุงเทพ' ? '#0A5188' : 'grey'
                "
                >กรุงเทพ/Bangkok</v-btn
              >
              <v-btn
                class="ml-1"
                @click="input.location_interest = 'ต่างจังหวัด'"
                rounded
                outlined
                style="letter-spacing: 0px !important"
                :style="
                  input.location_interest === 'ต่างจังหวัด'
                    ? 'font-weight: 600'
                    : ''
                "
                :color="
                  input.location_interest === 'ต่างจังหวัด' ? '#0A5188' : 'grey'
                "
                >ต่างจังหวัด/Province</v-btn
              >
            </div>
          </div> -->

          <div>
            <ValidationProvider :name="'event'" key="event" v-slot="{ errors }">
              <div class="steplabel">
                อีเวนต์ / Event
              </div>
              <div>
                <v-autocomplete
                  placeholder="อีเวนต์"
                  :error-messages="errors"
                  v-model="input.event_name"
                  :items="eventOptions"
                  outlined
                  rounded
                  clearable
                  no-data-text="ไม่พบข้อมูลอีเวนต์"
                >
                </v-autocomplete>
              </div>
            </ValidationProvider>
          </div>

          <div>
            <div class="steplabel mt-4">
              <span style="color: red">*</span>
              ลักษณะงานที่สนใจ / Job Interests
            </div>
            <div class="mt-1">
              <v-row dense>
                <v-col cols="12">
                  <div class="nocss">อันดับ1/First</div>
                </v-col>
                <v-col class="mb-2" cols="12">
                  <ValidationProvider
                    :name="'งานที่สนใจ'"
                    :rules="'required'"
                    key="งานที่สนใจอันดับ 1"
                    v-slot="{ errors }"
                  >
                    <div>
                      <span @click="showSelectJob(0)">
                        <v-text-field
                          readonly
                          placeholder="ลักษณะงานที่สนใจ"
                          :hide-details="errors.length ? false : true"
                          :error-messages="errors"
                          :value="input.job_interest[0]"
                          outlined
                          rounded
                        ></v-text-field>
                      </span>
                    </div>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <div class="nocss">อันดับ2/Second</div>
                </v-col>
                <v-col cols="12" class="mb-2">
                  <ValidationProvider
                    :name="'งานที่สนใจอันดับ 2'"
                    :rules="''"
                    key="งานที่สนใจอันดับ 2"
                    v-slot="{ errors }"
                  >
                    <div>
                      <span @click="showSelectJob(1)">
                        <v-text-field
                          readonly
                          placeholder="ลักษณะงานที่สนใจ"
                          :hide-details="errors.length ? false : true"
                          :error-messages="errors"
                          :value="input.job_interest[1]"
                          outlined
                          rounded
                        ></v-text-field>
                      </span>
                    </div>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-row dense justify="center" class="mt-10">
                <v-col cols="auto">
                  <v-btn
                    class="text-capitalize"
                    outlined
                    dark
                    large
                    rounded
                    :min-width="128"
                    @click="$store.state.step = 1"
                    color="grey"
                    >Back</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    class="text-capitalize"
                    dark
                    large
                    rounded
                    :min-width="128"
                    @click="next"
                    color="#0a5188"
                    >Next</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </div>
        </v-container>
      </div>
    </ValidationObserver>
    <v-dialog width="500px" v-model="selectjob" persistent>
      <v-card>
        <SelectJob
          v-if="selectjob"
          @onSave="onSelectJobinterest"
          @close="selectjob = false"
          :jobList="jobList"
        ></SelectJob>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import provinceOptions from "@/assets/js/province.js";
import axios from "axios";
import SelectJob from "./SelectJob.vue";

export default {
  components: {
    SelectJob,
  },
  data() {
    return {
      selectjob: false,
      currentJobIndex: null,
      input: {
        location_interest: "กรุงเทพ",
        job_interest: ["", "", ""],
        place_of_birth: "",
        current_address: "",
        event_name: "",
      },
      isLoading: false,
      jobList: [],
      eventList: [],
    };
  },
  computed: {
    provinceOptions() {
      return provinceOptions;
    },
    eventOptions() {
      return this.eventList.map((event) => event.name) || [];
    },
  },
  async mounted() {
    this.handleFetchMasterData();
  },
  methods: {
    async handleFetchMasterData() {
      try {
        this.isLoading = true;
        await Promise.all([this.fetchJobInterestData(), this.fetchEvents()]);
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },
    onSelectJobinterest({ type, job, location }) {
      this.$set(
        this.input.job_interest,
        this.currentJobIndex,
        `${type} - ${job}` + (location ? ` - ${location}` : ""),
      );
      this.selectjob = false;
    },
    showSelectJob(index) {
      this.currentJobIndex = index;
      this.selectjob = true;
    },
    async next() {
      var isValid = await this.$refs.observer.validate();

      if (isValid) {
        Object.assign(this.$store.state.profileinfo, {
          ...this.input,
          place_of_birth: this.input.place_of_birth.province_name,
          current_address: this.input.current_address.province_name,
        });
        this.$store.state.step = 3;
      }
    },
    async fetchJobInterestData() {
      const vm = this;
      try {
        const response = await axios.get(
          "https://api-enterprise.zwiz.app/api/bangkokbank/liff/job-interest-list",
          {
            params: {
              limit: 20,
              offset: 0,
              page_id: vm.query.pageid,
            },
          },
        );
        if (response.status === 200) {
          vm.jobList = response.data.data;
        } else {
          await vm.$swal.fire({
            icon: "error",
            text: response.data.reason,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        await vm.$swal.fire({
          icon: "error",
          text: "An error occurred while fetching data.",
        });
      }
    },
    async fetchEvents() {
      const vm = this;

      try {
        const response = await axios.get(
          "https://api-enterprise.zwiz.app/api/bangkokbank/liff/event",
          {
            params: {
              page_id: vm.query.pageid,
            },
          },
        );
        if (response.status === 200) {
          vm.eventList = response.data.data;
        } else {
          await vm.$swal.fire({
            icon: "error",
            text: response.data.reason,
          });
        }
      } catch (error) {
        console.error("Error fetching event:", error);
        await vm.$swal.fire({
          icon: "error",
          text: "An error occurred while fetching event.",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nocss {
  text-align: right !important;
  font-size: 15px;
  line-height: 38px;
}
</style>
